import { getSession } from "../api";
import { User, Tier, Type } from "../types";

const POLL_INTERVAL_MS = 2000;
const MAX_POLL_ATTEMPTS = 15;

export interface PollResult {
  user: User;
  confirmed: boolean;
}

export async function pollForSubscriptionUpdate(
  expectedTier: Tier,
  expectedType: Type
): Promise<PollResult> {
  for (let i = 0; i < MAX_POLL_ATTEMPTS; i++) {
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));

    const freshUser = await getSession();
    const actualSub = freshUser.subscriptions?.find(
      (s) => s.type === expectedType
    );

    if (actualSub?.tier === expectedTier) {
      return { user: freshUser, confirmed: true };
    }
  }

  // Timeout - return latest state but indicate not confirmed
  const freshUser = await getSession();
  return { user: freshUser, confirmed: false };
}
